import React from 'react'

const Shows = () => {
  return (
    <>
      <div class="shows">
		<div class="container">
			<div class="row" style={{"z-index":10}}>
				<div class="col">
					<div class="section_title_container">
						<div class="section_subtitle">Events</div>
						<div class="section_title"><h1>Upcoming Shows</h1></div>
					</div>
				</div>
			</div>
			<div class="row shows_row">
				
				<div class="col-lg-8 order-lg-1 order-2 shows_list_col">
					<div class="shows_list_container">
						<ul class="shows_list">

							<li class="d-flex flex-row align-items-center justify-content-start">
								<div><div class="show_date">18/07</div></div>
								<div class="show_info d-flex flex-md-row flex-column align-items-md-center align-items-start justify-content-md-start justify-content-center">
									<div class="show_name"><a href="#">Electric Castle Festival</a></div>
									<div class="show_location">Cluj, Romania</div>
								</div>
								<div class="ml-auto"><div class="show_shop trans_200"><a href="#">Buy Tickets</a></div></div>
							</li>

							<li class="d-flex flex-row align-items-center justify-content-start">
								<div><div class="show_date">20/07</div></div>
								<div class="show_info d-flex flex-md-row flex-column align-items-md-center align-items-start justify-content-md-start justify-content-center">
									<div class="show_name"><a href="#">Ultra Music Festival</a></div>
									<div class="show_location">Miami, USA</div>
								</div>
								<div class="ml-auto"><div class="show_shop trans_200"><a href="#">Buy Tickets</a></div></div>
							</li>

							<li class="d-flex flex-row align-items-center justify-content-start">
								<div><div class="show_date">03/08</div></div>
								<div class="show_info d-flex flex-md-row flex-column align-items-md-center align-items-start justify-content-md-start justify-content-center">
									<div class="show_name"><a href="#">Untold Festival</a></div>
									<div class="show_location">Cluj, Romania</div>
								</div>
								<div class="ml-auto"><div class="show_shop trans_200"><a href="#">Buy Tickets</a></div></div>
							</li>

							<li class="d-flex flex-row align-items-center justify-content-start">
								<div><div class="show_date">11/08</div></div>
								<div class="show_info d-flex flex-md-row flex-column align-items-md-center align-items-start justify-content-md-start justify-content-center">
									<div class="show_name"><a href="#">Sun Kissed Festival</a></div>
									<div class="show_location">Paris, France</div>
								</div>
								<div class="ml-auto"><div class="show_shop trans_200"><a href="#">Buy Tickets</a></div></div>
							</li>

							<li class="d-flex flex-row align-items-center justify-content-start">
								<div><div class="show_date">18/08</div></div>
								<div class="show_info d-flex flex-md-row flex-column align-items-md-center align-items-start justify-content-md-start justify-content-center">
									<div class="show_name"><a href="#">Spanish Festival</a></div>
									<div class="show_location">Madrid, Spain</div>
								</div>
								<div class="ml-auto"><div class="show_shop trans_200"><a href="#">Buy Tickets</a></div></div>
							</li>

							<li class="d-flex flex-row align-items-center justify-content-start">
								<div><div class="show_date">25/08</div></div>
								<div class="show_info d-flex flex-md-row flex-column align-items-md-center align-items-start justify-content-md-start justify-content-center">
									<div class="show_name"><a href="#">Vikings Festival</a></div>
									<div class="show_location">Oslo, Norway</div>
								</div>
								<div class="ml-auto"><div class="show_shop trans_200"><a href="#">Buy Tickets</a></div></div>
							</li>

						</ul>
					</div>
				</div>

				<div class="col-lg-4 order-lg-2 order-1">
					<div class="shows_image">
						<div class="image_overlay"></div>
						<img src="images/dani.jpg" alt="https://unsplash.com/@anthonydelanoix" />
					</div>
				</div>

			</div>
		</div>
	</div>

    </>
  )
}

export default Shows
